import { RouteType } from "types/RouteType";
import { routesWithAuth } from "../stores/RouterStore/authRoutes";
import adminRoutesList from "./admin/adminRoutesList";
import accountingRoutesList from "./accounting/accountingRoutesList";
import crmRoutesList from "./crm/crmRoutesList";
import productRoutesList from "./product/productRoutesList";
import dispatchRoutesList from "./dispatch/dispatchRoutesList";
import productionRoutesList from "./production/productionRoutesList";
import operationsRoutesList from "./operations/operationsRoutesList";
import schedulingRoutesList from "./scheduling/schedulingRoutesList";
import qualityControlRoutesList from "./qualityControl/qualityControlRoutesList";
import inventoryAndFieldRoutesList from "./inventoryAndField/inventoryAndFieldRoutesList";
import yardRoutesList from "./yard/yardRoutesList";
import projectManagementRoutesList from "./projectManagement/projectManagementRoutesList";
import administrationRoutesList from "./administration/administrationRoutesList";
import settingsRoutesList from "./settings/settingsRoutesList";
import estimatingRoutesList from "./estimating/estimatingRoutesList";
import castStoneRoutesList from "./castStone/castStoneRoutesList";
import purchasingRoutesList from "./purchasing/purchasingRoutesList";
import QuoteToProductionRoute from "./purchasing/quote-conversion/QuoteToProduction.Route";
import BomImportRoute from "./purchasing/bom-import/BomImport.Route";
import MaterialsRoute from "./materials/Materials.Route";
import fieldReportingRoutesList from "./fieldReporting/fieldReportingRoutesList";
import workflowsRoutesList from "./workflows/workflowsRoutesList";
import PdfEditorRoute from "./pdf/editor/PdfEditor.Route";
import PdfManagementRoute from "./pdf/management/PdfManagement.Route";
import BomExtractionRoute from "./bom-extraction/BomExtraction.Route";
import DrawingDimensionRoute from "./drawing-dimension-extractor/DrawingDimension.Route";
import { generateServiceViewRoutes } from "../stores/RouterStore/utils/ServiceViewRouteGenerator";
import serviceStores from "../serviceStoresConfig";
import millerMizeRoutesList from "./millermize/millerMizeRoutesList";

// Generate dynamic service view routes
const serviceViewRoutes = generateServiceViewRoutes(serviceStores);

const routesList: RouteType[] = [
  ...routesWithAuth,
  ...adminRoutesList,
  // ...accountingRoutesList,
  // ...crmRoutesList,
  ...productRoutesList,
  ...dispatchRoutesList,
  ...productionRoutesList,
  ...operationsRoutesList,
  ...schedulingRoutesList,
  ...qualityControlRoutesList,
  ...inventoryAndFieldRoutesList,
  ...yardRoutesList,
  ...projectManagementRoutesList,
  ...administrationRoutesList,
  ...settingsRoutesList,
  ...estimatingRoutesList,
  ...castStoneRoutesList,
  ...purchasingRoutesList,
  QuoteToProductionRoute,
  BomImportRoute,
  MaterialsRoute,
  ...fieldReportingRoutesList,
  ...workflowsRoutesList,
  PdfManagementRoute,
  PdfEditorRoute,
  BomExtractionRoute,
  DrawingDimensionRoute,
  // ...serviceViewRoutes, // Hidden for now
  ...millerMizeRoutesList,
];

export default routesList;
